import React from 'react';
import PropTypes from 'prop-types';

import MuiCheckbox from '@material-ui/core/Checkbox';
import { useCheckboxStyles } from './checkboxStyles';

/**
 * Default Checkbox component based on https://material-ui.com/components/checkboxes/#checkbox
 * @param {} props All possible props can be found in docs https://material-ui.com/api/checkbox/
 */

export default function Checkbox(props) {
  const classes = useCheckboxStyles();
  return (
    <MuiCheckbox
      {...props}
      classes={{
        ...classes,
      }}
    />
  );
}

Checkbox.propTypes = {
  /**
   * Should it be disabled?
   */
  disabled: PropTypes.bool,
  /**
   * Is checkbox checked
   */
  checked: PropTypes.bool,
  /**
   * Name by which checkbox can be identified
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  disabled: false,
};
